<template>
  <b-card
    @click="showUpdateMatch"
    no-body
    style="width:220px; cursor: pointer"
    class="mt-1 ml-1"
  >
    <b-row
      :class="{
        'mr-0 ml-0 rounded-top por-jugar': partido.final == 'PJ',
        'mr-0 ml-0 rounded-top jugado bg-primary':
          (partido.final != 'PJ') &
          (partido.reset_opcion == null || partido.reset_opcion == '0'),
        'mr-0 ml-0 rounded-top sancionado':
          (partido.final != 'PJ') &
          (partido.reset_opcion != null && partido.reset_opcion != 0),
      }"
    >
      <!-- <b-col md="3" style="margin:0;padding-left:10px">
        <b style="font-size:12px;">F: {{ partido.numero_fecha }} </b>
      </b-col> -->
      <b-col md="8" >
        <span style="font-size:11px"
          >{{ partido.fecha }} / {{ partido.horario }}</span
        >
      </b-col>
      <b-col md="4" style="paddin:0;text-align:right" >
        <span style="font-size:9px;">{{ partido.id_partido }} </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex align-items-center justify-content-center">
        <!-- <b-avatar
          square
          src="https://play-gol.com/optimiza/fotos_equ/esc14.png"
        /> -->
        <img :src="partido.foto_local" alt="ND" width="40" />
      </b-col>
      <b-col class="d-flex align-items-center justify-content-center">
        <img :src="partido.foto_visita" alt="ND" width="40" />
        <!-- <b-avatar src="https://play-gol.com/optimiza/fotos_equ/esc342.png" /> -->
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center nombre-equipo text-truncate " md="6" lg="6">
        {{ partido.nom_local }}
      </b-col>
      <!-- <b-col md="1" class="ml-0 mr-0">
                  <span>vs</span>
              </b-col> -->
      <b-col class="text-center nombre-equipo text-truncate" md="6" lg="6">
        {{ partido.nom_visita }}
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center" md="6" lg="6">
        <b v-if="partido.final == 'PJ'">-</b>
        <b v-else-if="partido.final == 'NPN'">-</b>
        <b v-else>{{ partido.goles_local }}</b>
        <span
          v-if="partido.penales == 's'"
          style="font-size:14px;color:darkgray"
          >({{ partido.penal_local }})</span
        >
      </b-col>
      <!-- <b-col md="1" class="ml-0 mr-0">
                  <span>vs</span>
              </b-col> -->
      <b-col class="text-center" md="6" lg="6">
        <b v-if="partido.final == 'PJ'">-</b>
        <b v-else-if="partido.final == 'NPN'">-</b>
        <b v-else>{{ partido.goles_visita }}</b>
        <span
          v-if="partido.penales == 's'"
          style="font-size:14px;color:darkgray"
          >({{ partido.penal_visita }})</span
        >
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
// import store from '@/store'
import {
  BCard,
  BRow,
  BCol,
  //   BAvatar,
  // BXX,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    // BAvatar,
  },
  props: {
    partido: Object,
  },
  setup(props, { emit }) {
    function showUpdateMatch() {
      // store.commit('someVariables/UPDATE_SHOW_UPDATE_MATCH', true)
      emit('getDetalleMatch', props.partido)
    }
    return {
      showUpdateMatch,
    }
  },
}
</script>
<style scoped>
.por-jugar {
  background-color: #7a8483;
  color: white;
  margin-bottom: 5px;
}
.sancionado {
  background-color: #b360d1;
  color: white;
  margin-bottom: 5px;
}

.jugado {
  color: white;
  margin-bottom: 5px;
}
</style>
